import { Icon } from 'gu-ui-kit'
import React, { lazy } from 'react'
import { ROUTES } from 'constants/routes'

import AuthLogin from 'modules/Auth/Login'
import AuthRegistration from 'modules/Auth/Registration'
import AuthRecover from 'modules/Auth/Recover'
import AuthRecoverSent from 'modules/Auth/RecoverSent'
import AuthDoubleFA from 'modules/Auth/DoubleFA'
import AuthAdmitadOauth from 'modules/Auth/AdmitadOauth'
import AuthActivation from 'modules/Auth/Activation'
import AuthRecoverPassword from 'modules/Auth/RecoverPassword'

import ServicesList from 'modules/Services/NetworksList'
import ServicesNetwork from 'modules/Services/Network'
import ServicesNetworkMediaPlanner from 'modules/MediaPlanner/MediaPlanner'
import ServicesNetworkAccount from 'modules/Services/Account'
import ServicesNetworkAccountRefund from 'modules/Services/Refund'
import ServicesNetworkAccountAccess from 'modules/Services/Access/List'
import ServicesNetworkAccountAccessCreate from 'modules/Services/Access/Create'
import ServicesNetworkAccountCampaigns from 'modules/Services/Campaigns/Main'
import ServicesNetworkAccountCampaignCreate from 'modules/Services/Campaigns/Create'
import ServicesNetworkAccountCampaignStart from 'modules/Services/Campaigns/Start'
import ServicesNetworkAccountCreate from 'modules/Services/AccountCreate'
import ServicesNetworkCampaignsEditor from 'modules/Services/CampaignsEditor'

import AgencyCard from 'modules/Agency/AgencyCard'
import Clients from 'modules/Agency/Clients'
import Requests from 'modules/Agency/Requests'
import AddClient from 'modules/Agency/AddClient'
import Transfer from 'modules/Agency/Transfer'

import ReferralList from 'modules/Referral/List'
import ReferralPayout from 'modules/Referral/PayoutCreate'
import ReferralInvoices from 'modules/Referral/PayoutProfiles/Invoices'

import PayoutProfiles from 'modules/Referral/PayoutProfiles/List'
import PayoutProfilesCreate from 'modules/Referral/PayoutProfiles/Create'
import StatisticsMain from 'modules/Statistics/Main'
import StatisticsAccount from 'modules/Statistics/Account'
// import StatisticsAccountConnect from 'modules/Statistics/subcomponents/AccountConnect'
import StatisticsCampaign from 'modules/Statistics/Campaign'

import Settings from 'modules/User/Settings'
import Password from 'modules/User/Security/Password'
import DoubleFA from 'modules/User/Security/2fa'
import DoubleFASetup from 'modules/User/Security/2fa/Setup'

//Billing
import AccountReplenish from 'modules/Billing/AccountReplenish'
import DepositReplenish from 'modules/Billing/DepositReplenish'
import AccountsReplenish from 'modules/Billing/AccountsReplenish'
import DepositCreationFee from 'modules/Billing/DepositCreationFee'
import BillingPaymentOrder from 'modules/Billing/PaymentOrder'

import AutoReplenish from 'modules/AutoReplenish'
import OauthAuth from 'modules/Oauth/Auth'
import OauthCode from 'modules/Oauth/Code'

// Finance
import Finance from 'modules/Finance'
import Wallets from 'modules/Finance/Wallets'
import PromisedPayment from 'modules/Finance/PromisedPayment'
import PromisedPaymentRequest from 'modules/Finance/PromisedPayment/Request'
import Invoices from 'modules/Finance/Invoices'
import PaymentProfiles from 'modules/Finance/PaymentProfiles'
import PaymentProfilesCreate from 'modules/Finance/PaymentProfiles/Create'

import PaymentsReturnUrl from 'modules/ReturnUrl/Payments'
import TargetMailCode from 'modules/ReturnUrl/TargetMailCode'
import VkCode from 'modules/ReturnUrl/VkCode'
import VkAdsMarketCode from 'modules/ReturnUrl/VkAdsMarketCode'
import VkAdsCode from 'modules/ReturnUrl/VkAdsCode'

// import TicketsList from 'modules/Tickets/List'
import TicketOpener from 'components/TicketsPanel/TicketOpener'

import LocalPay from 'modules/LocalPay'

//Referral
import ReferralClients from 'modules/Referral/ReferralClients'
import ReferralLinks from 'modules/Referral/ReferralLinks'
import ReferralLinksCreate from 'modules/Referral/ReferralLinks/CreateLink'
import ReferralLinksEdit from 'modules/Referral/ReferralLinks/EditLink'
import YandexAdsCode from 'modules/ReturnUrl/YandexAdsCode'

const ServicesNetworkAccountAdvertiserInfoEdit = lazy(() =>
  import('modules/Services/AccountAdvertiserInfoEdit'),
)
const ServicesNetworkCampaignsEditorDefault = lazy(() =>
  import('modules/Services/CampaignsEditor/Default'),
)

const unAuthorizedRoutes = [
  {
    path: ROUTES.PAYMENT_ORDER,
    component: BillingPaymentOrder,
    exact: true,
    key: 'payment-order',
    layout: 'custom',
  },
  {
    path: ROUTES.AUTH_REGISTRATION,
    component: AuthRegistration,
    exact: true,
    key: 'registration',
    layout: 'auth',
  },
  {
    path: ROUTES.AUTH_LOGIN,
    component: AuthLogin,
    exact: true,
    key: 'login',
    layout: 'auth',
  },
  {
    path: ROUTES.AUTH_ACTIVATION,
    component: AuthActivation,
    exact: true,
    key: 'activation',
    layout: 'auth',
  },
  {
    path: ROUTES.AUTH_RECOVER_WITH_EMAIL,
    component: AuthRecover,
    exact: true,
    key: 'recover-with-email',
    layout: 'auth',
  },
  {
    path: ROUTES.AUTH_RECOVER,
    component: AuthRecover,
    exact: true,
    key: 'recover',
    layout: 'auth',
  },
  {
    path: ROUTES.AUTH_RECOVER_SENT,
    component: AuthRecoverSent,
    exact: true,
    key: 'recover-sent',
    layout: 'auth',
  },
  {
    path: ROUTES.AUTH_RECOVER_SET_PASSWORD,
    component: AuthRecoverPassword,
    exact: true,
    key: 'password-recover',
    layout: 'auth',
  },
  {
    path: ROUTES.AUTH_LOGIN_2FA,
    component: AuthDoubleFA,
    exact: true,
    key: '2fa',
    layout: 'auth',
  },
  {
    path: ROUTES.AUTH_ADMITAD_CHECK,
    component: AuthAdmitadOauth,
    exact: true,
    key: 'admitad-oauth',
  },
]

const authorizedRoutes = [
  {
    path: ROUTES.LOCAL_PAY,
    component: LocalPay,
    exact: true,
    key: 'local-pay',
  },
  {
    path: [
      ROUTES.QIWI_SUCCESS,
      ROUTES.QIWI_DECLINE,
      ROUTES.PAYMASTER_SERVICE_RESULT,
      ROUTES.PAYMENT_RESULT,
      ROUTES.BILLING_PAYMENT_RESULT,
      ROUTES.BILLING_TOP_UP_RESULT,
    ],
    component: () => <PaymentsReturnUrl />,
    key: 'payment_return_url',
  },
  {
    layout: 'wide',
    path: ROUTES.AGENCY_ADD_CLIENT,
    exact: true,
    key: 'agency/add-client',
    icon: (
      <Icon
        name="orders"
        size="m"
      />
    ),
    label_key: 'agency::navigation.add-client',
    component: AddClient,
  },
  {
    path: ROUTES.TARGET_MAIL_CODE,
    component: () => <TargetMailCode />,
    key: 'target_mail_code_check',
  },
  {
    path: ROUTES.VK_CODE,
    component: () => <VkCode />,
    key: 'vk-code',
  },
  {
    path: ROUTES.ADSMARKET_CODE,
    component: () => <VkAdsMarketCode />,
    key: 'vk_code',
  },
  {
    path: ROUTES.VK_ADS_CODE,
    component: () => <VkAdsCode />,
    key: 'vk-ads-code',
  },
  {
    path: ROUTES.YANDEX_ADS_CODE,
    component: () => <YandexAdsCode />,
    key: 'yandex-ads-code',
  },
  {
    path: ROUTES.AUTOREPLENISH,
    exact: true,
    key: 'auto_replenish',
    label_key: 'common::nav_menu.auto_replenish',
    component: () => <AutoReplenish />,
    layout: 'wide',
  },
  {
    path: ROUTES.SERVICES_NETWORK_ACCOUNT_REGISTER,
    exact: true,
    key: 'service_account_register',
    label_key: 'common::nav_menu.network_account_register',
    component: ServicesNetworkAccountCreate,
    layout: 'custom',
    restyled: true,
  },
  {
    path: ROUTES.SERVICES_NETWORK_ACCOUNT_MULTIREGISTER,
    exact: true,
    key: 'service_account_register_multilogin',
    label_key: 'common::nav_menu.network_account_register',
    component: () => <ServicesNetworkAccountCreate multiLogins />,
    layout: 'custom',
    restyled: true,
  },
  {
    restyled: true,
    path: ROUTES.SERVICES_NETWORK_ACCOUNT_ADVERTISER_INFO_EDIT,
    exact: true,
    key: 'service_network_account_tax_info_edit',
    label_key: 'common::nav_menu.network_account_tax_info_edit',
    component: ServicesNetworkAccountAdvertiserInfoEdit,
    layout: 'custom',
  },
  {
    path: [ROUTES.SERVICES_NETWORK_ACCOUNT_ACCESS_NEW, ROUTES.SERVICES_NETWORK_ACCOUNT_ACCESS_EDIT],
    exact: true,
    key: 'service_network_account_access_create',
    label_key: 'common::nav_menu.network_access_create',
    component: ServicesNetworkAccountAccessCreate,
    layout: 'custom',
  },
  {
    path: [ROUTES.REFERRAL_PAYOUT_PROFILE_NEW, ROUTES.REFERRAL_PAYOUT_PROFILE_EDIT],
    exact: true,
    key: 'referral/payout-profiles-new',
    label_key: 'referral::navigation.payout-profiles-new',
    component: PayoutProfilesCreate,
    layout: 'wide',
    icon: (
      <Icon
        name={'doc'}
        size={'m'}
      />
    ),
  },
  {
    path: ROUTES.SERVICES_NETWORK_ACCOUNT_REFUND,
    exact: true,
    key: 'service_network_account_refund',
    label_key: 'common::nav_menu.network_account_refund',
    component: ServicesNetworkAccountRefund,
    layout: 'wide',
    restyled: true,
  },
  {
    exact: true,
    path: ROUTES.REFERRAL_PAYOUT,
    key: 'referral/payout',
    label_key: 'referral::navigation.payout',
    component: ReferralPayout,
    icon: (
      <Icon
        name={'user'}
        size={'m'}
      />
    ),
  },
  {
    path: ROUTES.SERVICES,
    exact: true,
    key: 'services_list',
    label_key: 'common::nav_menu.advertisement_networks',
    component: ServicesList,
    restyled: true,
    icon: (
      <Icon
        name="gramophone"
        size="m"
      />
    ),
  },
  {
    path: ROUTES.SERVICES_NETWORK_ACCOUNT,
    exact: true,
    key: 'service_network_account',
    label_key: 'common::nav_menu.network_account',
    component: ServicesNetworkAccount,
    restyled: true,
  },
  {
    restyled: true,
    path: ROUTES.SERVICES_NETWORK_ACCOUNT_ACCESS,
    exact: true,
    key: 'service_network_account_access_management',
    label_key: 'common::nav_menu.network_access_management',
    component: ServicesNetworkAccountAccess,
  },
  {
    path: ROUTES.SERVICES_NETWORK_CAMPAIGNS_EDITOR_DEFAULT,
    exact: true,
    key: 'service_campaigns_editor',
    label_key: 'services::campaigns_editor.title',
    component: ServicesNetworkCampaignsEditorDefault,
  },
  {
    path: ROUTES.SERVICES_NETWORK_CAMPAIGNS_EDITOR,
    key: 'service_campaigns_editor_resource',
    label_key: 'services::campaigns_editor.title',
    component: ServicesNetworkCampaignsEditor,
  },
  {
    path: ROUTES.SERVICES_NETWORK_ACCOUNT_CAMPAIGNS,
    exact: true,
    key: 'service_network_account_campaigns',
    label_key: 'common::nav_menu.network_account_campaigns',
    component: ServicesNetworkAccountCampaigns,
  },
  {
    path: ROUTES.SERVICES_NETWORK_ACCOUNT_CAMPAIGN_NEW,
    exact: true,
    key: 'service_network_account_campaign_create',
    label_key: 'common::nav_menu.network_account_campaign_create',
    component: ServicesNetworkAccountCampaignCreate,
  },
  {
    path: ROUTES.SERVICES_NETWORK_ACCOUNT_CAMPAIGN_START,
    exact: true,
    key: 'service_network_account_campaign_start',
    label_key: 'common::nav_menu.network_account_campaign_start',
    component: ServicesNetworkAccountCampaignStart,
  },
  {
    restyled: true,
    path: ROUTES.SERVICES_NETWORK_MEDIA_PLANNER,
    exact: true,
    key: 'service_media_planner_page',
    label_key: 'common::nav_menu.network_media_planner',
    component: ServicesNetworkMediaPlanner,
  },
  {
    path: ROUTES.SERVICES_NETWORK,
    exact: true,
    key: 'service_page',
    label_key: 'common::nav_menu.network',
    component: ServicesNetwork,
    restyled: true,
  },
  {
    path: ROUTES.STATISTICS,
    exact: true,
    label_key: 'statistics::navigation.main',
    key: 'statistics_main',
    component: StatisticsMain,
    restyled: true,
    icon: (
      <Icon
        name={'statistics'}
        size="m"
      />
    ),
  },
  {
    exact: true,

    path: ROUTES.STATISTICS_ACCOUNT,
    label_key: 'statistics::navigation.account',
    key: 'statistics_account',
    component: StatisticsAccount,
  },
  {
    exact: true,

    path: ROUTES.STATISTICS_CAMPAIGN,
    label_key: 'statistics::navigation.campaign',
    key: 'statistics_campaign',
    component: StatisticsCampaign,
  },
  // {
  //   path: ROUTES.STATISTICS_ACCOUNT_CONNECT,
  //   exact: true,
  //   label_key: 'statistics::navigation.account_connect',
  //   key: 'statistics_account_connect',
  //   component: StatisticsAccountConnect,
  // },
  {
    path: ROUTES.REFERRAL_LINKS_CREATE,
    exact: true,
    key: 'referral/links/create',
    label_key: 'referral::navigation.referral-links-create',
    component: ReferralLinksCreate,
    layout: 'custom',
  },
  {
    path: ROUTES.REFERRAL_LINKS_EDIT,
    exact: true,
    key: 'referral/links/edit',
    label_key: 'referral::navigation.referral-links-edit',
    component: ReferralLinksEdit,
    layout: 'custom',
  },
  {
    path: ROUTES.REFERRAL_LINKS,
    exact: true,
    key: 'referral/links',
    icon: (
      <Icon
        name="copy-link"
        size="m"
      />
    ),
    label_key: 'referral::navigation.referral-links',
    component: ReferralLinks,
  },
  {
    exact: true,
    path: ROUTES.REFERRAL,
    key: 'referral/main',
    label_key: 'referral::navigation.referral',
    component: ReferralList,
    icon: (
      <Icon
        name={'user'}
        size={'m'}
      />
    ),
  },
  {
    exact: true,
    path: ROUTES.REFERRALS,
    key: 'referrals/main',
    label_key: 'referral::navigation.referrals',
    component: ReferralList,
    icon: (
      <Icon
        name={'user'}
        size={'m'}
      />
    ),
  },
  {
    path: ROUTES.REFERRAL_CLIENTS,
    exact: true,
    key: 'referral/referral-clients',
    icon: (
      <Icon
        name="users"
        size="m"
      />
    ),
    label_key: 'referral::navigation.referral-clients',
    component: ReferralClients,
  },
  {
    exact: true,
    path: ROUTES.REFERRAL_PAYOUT_PROFILES,
    key: 'referral/payout-profiles',
    label_key: 'referral::navigation.payout-profiles',
    component: PayoutProfiles,
    icon: (
      <Icon
        name={'input'}
        size={'m'}
      />
    ),
  },
  {
    exact: true,
    path: ROUTES.REFERRAL_PAYOUT_PROFILE_INVOICES,
    key: 'referral/payouts-list',
    label_key: 'referral::navigation.payouts-list',
    component: ReferralInvoices,
    icon: (
      <Icon
        name={'money'}
        size={'m'}
      />
    ),
  },

  //Пользовательские настройки
  {
    exact: true,
    restyled: true,
    path: ROUTES.USER_SETTINGS,
    key: 'user/settings',
    label_key: 'user::navigation.settings',
    component: Settings,
    icon: (
      <Icon
        name={'user'}
        size={'m'}
      />
    ),
  },
  {
    exact: true,
    restyled: true,
    layout: 'wide',
    path: ROUTES.USER_SECURITY_PASSWORD,
    key: 'user/security/password',
    label_key: 'user::navigation.password',
    component: Password,
  },
  {
    exact: true,
    restyled: true,
    layout: 'wide',
    path: ROUTES.USER_SECURITY_2FA,
    key: 'user/security/2fa',
    label_key: 'user::navigation.2fa',
    component: DoubleFA,
  },

  {
    exact: true,
    restyled: true,
    layout: 'wide',
    path: ROUTES.USER_SECURITY_2FA_SETTING,
    key: 'user/security/2fa/setup',
    label_key: 'user::navigation.2fa',
    component: DoubleFASetup,
  },
  //Формы пополнения тут
  {
    layout: 'wide',
    exact: true,
    path: ROUTES.BILLING_TOP_UP,
    key: 'billing/top-up/deposit',
    label_key: 'billing::navigation.deposit',
    component: DepositReplenish,
    restyled: true,
  },
  {
    layout: 'wide',
    exact: true,
    path: ROUTES.BILLING_TOP_UP_ACCOUNT,
    key: 'billing/top-up/account',
    label_key: 'billing::navigation.account',
    component: AccountReplenish,
    restyled: true,
  },
  {
    layout: 'wide',
    exact: true,
    path: ROUTES.BILLING_TOP_UP_ACCOUNTS,
    key: 'billing/top-up/accounts',
    label_key: 'billing::navigation.deposit_accounts',
    component: AccountsReplenish,
    restyled: true,
  },
  {
    layout: 'wide',
    exact: true,
    path: ROUTES.BILLING_DEPOSIT_CREATION_FEE,
    key: 'billing/deposit-creation-fee',
    label_key: 'billing::navigation.deposit_creation_fee',
    component: DepositCreationFee,
    restyled: true,
  },

  //FINANCE
  {
    path: ROUTES.FINANCE,
    key: 'finance',
    label_key: 'finance::navigation.wallets',
    component: Finance,
    icon: (
      <Icon
        name="money"
        size="m"
      />
    ),
    routes: [
      {
        exact: true,
        restyled: true,
        path: ROUTES.FINANCE_WALLETS,
        key: 'finance/wallets',
        label_key: 'finance::navigation.wallets',
        component: Wallets,
        icon: (
          <Icon
            name="money"
            size="m"
          />
        ),
      },
      {
        exact: true,
        restyled: true,
        path: ROUTES.FINANCE_WALLET,
        key: 'finance/wallet',
        label_key: 'finance::navigation.wallets',
        component: Wallets,
      },
      {
        exact: true,
        restyled: true,
        path: ROUTES.FINANCE_PAYMENT_PROFILES,
        key: 'finance/payment-profiles',
        label_key: 'finance::navigation.payment_profiles',
        component: PaymentProfiles,
        icon: (
          <Icon
            name={'user'}
            size={'m'}
          />
        ),
      },
      {
        exact: true,
        path: ROUTES.FINANCE_INVOICES,
        key: 'finance/invoices',
        label_key: 'finance::navigation.invoices',
        component: Invoices,
        icon: (
          <Icon
            name={'doc'}
            size={'m'}
          />
        ),
      },
      {
        exact: true,
        path: ROUTES.FINANCE_PROMISED_PAYMENT,
        key: 'finance/promised-payment',
        label_key: 'finance::navigation.promised_payment',
        component: PromisedPayment,
        icon: (
          <Icon
            name={'orders'}
            size={'m'}
          />
        ),
      },
    ],
  },
  {
    path: [ROUTES.FINANCE_PAYMENT_PROFILE_NEW, ROUTES.FINANCE_PAYMENT_PROFILE_EDIT],
    layout: 'wide',
    exact: true,
    restyled: true,
    key: 'finance/payment-profiles-new',
    label_key: 'user::navigation.payment-profiles-new',
    component: PaymentProfilesCreate,
    icon: (
      <Icon
        name={'doc'}
        size={'m'}
      />
    ),
  },
  {
    exact: true,
    path: ROUTES.FINANCE_PROMISED_PAYMENT_REQUEST,
    key: 'finance/promised-payment-request',
    label_key: 'finance::navigation.promised_payment_request',
    layout: 'wide',
    component: PromisedPaymentRequest,
  },
  {
    path: ROUTES.OAUTH_CODE,
    exact: true,
    label_key: 'common::nav_menu.oauth_code',
    key: 'oauth_code',
    component: OauthCode,
  },
  {
    path: ROUTES.OAUTH_AUTH,
    exact: true,
    label_key: 'common::nav_menu.oauth_auth',
    key: 'oauth_auth',
    component: OauthAuth,
  },

  //TICKETS
  {
    layout: 'custom',
    path: [ROUTES.TICKETS, ROUTES.TICKET_NEW, ROUTES.TICKET],
    exact: true,
    key: 'tickets/ticket',
    label_key: 'tickets::navigation.ticket_new',
    component: TicketOpener,
  },

  //AGENCY
  {
    path: ROUTES.AGENCY_REQUESTS,
    exact: true,
    key: 'agency/requests',
    icon: (
      <Icon
        name="comments"
        size="m"
      />
    ),
    label_key: 'agency::navigation.requests',
    component: Requests,
  },
  {
    path: ROUTES.AGENCY_CLIENTS,
    exact: true,
    key: 'agency/clients',
    icon: (
      <Icon
        name="user"
        size="m"
      />
    ),
    label_key: 'agency::navigation.clients',
    component: Clients,
  },
  {
    restyled: true,
    path: ROUTES.AGENCY,
    exact: true,
    key: 'agency/main',
    icon: (
      <Icon
        name="heart"
        size="m"
      />
    ),
    label_key: 'agency::navigation.my_agency',
    component: AgencyCard,
  },
  {
    path: ROUTES.AGENCY_TRANSFER,
    exact: true,
    key: 'agency/transfer',
    icon: (
      <Icon
        name="clients"
        size="m"
      />
    ),
    label_key: 'agency::navigation.transfer',
    component: Transfer,
  },
]

export { unAuthorizedRoutes as unAuthorizedRoutes }
export { authorizedRoutes as authorizedRoutes }
